<template>
  <!-- eslint-disable -->
  <v-btn
    :block="block"
    :depressed="depressed"
    :fab="fab"
    :icon="icon"
    :loading="loading"
    :disabled="disabled"
    :outlined="outlined"
    :plain="plain"
    :x-small="xsmall"
    :small="small"
    :large="large"
    :x-large="xlarge"
    :elevation="elevation"
    @click="callback"
    class="btn main-shadow"
    @keydown="callback"
    :aria-label="name"
    :class="[
      {'black-text': green},
      {greenBtn: green},
      {redBtn: red},
      {yellowBtn: yellow},
      {whiteBtn: whiteBtn},
      {paddingBtn: iconText},
      ...extraClass,
    ]"
    v-bind="$attrs"
    v-on="$listeners"
    :type="type"
  >
    <span class="svg-prepend" v-if="svg">
      <slot name="svg-prepend">
        <!-- Ícone SVG à esquerda -->
      </slot>
    </span>

    <v-icon
      class="left-icon"
      v-if="!svg && iconLeft"
      left
      :style="{ 'font-size': iconSize, 'color': iconColor }"
    >
      <slot name="prepend-icon">
        <!-- Ícone material-mdi à esquerda -->
      </slot>
    </v-icon>

    <v-icon
      class="just-icon"
      v-if="!svgCenter && !svg && (icon || fab)"
      :style="{ 'font-size': iconSize, 'color': iconColor }"
    >
      <slot name="icon">
        <!-- Ícone do botão -->
      </slot>
    </v-icon>

    <div v-if="iconText && !svg">
      <div class="iconText" v-if="iconText && !carouselBtn">
        <v-icon :style="{ 'font-size': iconSize, 'color': iconColor }">
          <slot name="iconText">
            <!-- Ícone do botão com texto -->
          </slot>
        </v-icon>
      </div>
      <div class="textSlot" v-html="vHtml"></div>
    </div>
    <slot v-else></slot>

    <v-icon
      class="right-icon"
      v-if="!svg && iconRight" right
      :style="(iconSize !== '') ? `font-size: ${iconSize};` : ''"
    >
      <slot name="postpend-icon">
        <!-- Ícone material-mdi à direita -->
      </slot>
    </v-icon>

    <span class="svg-postpend" v-if="svg">
      <slot name="svg-postpend">
        <!-- SVG à direita -->
      </slot>
    </span>

    <span class="svg-center" v-if="svgCenter">
      <slot name="svg-center">
        <!-- SVG ao centro -->
      </slot>
    </span>
  </v-btn>
</template>

<script>
// Botão padrão do sistema.
export default {
  name: 'ButtonDefault',
  props: {
    // Método de chamada do botão
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },
    // Se o botão possui um ícone SVG
    svg: {
      type: Boolean,
      required: false,
      default: false,
    },
    svgCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão ocupa toda a área do container pai
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é flat (sem sombra)
    depressed: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é um botão flutuante
    fab: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se possui um ícone da biblioteca material-mdi
    icon: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se é um botão que possui ícon e texto um sobre o outro
    iconText: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Conteúdo do botão que aceita HTML
    vHtml: {
      type: String,
      required: false,
      default: '',
    },
    // Tipo do botão, conforme tipos disponíveis no Vuetify
    type: {
      type: String,
      required: false,
      default: '',
    },
    // Se é um botão da página inicial
    carouselBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Cor do ícone
    iconColor: {
      type: String,
      required: false,
      default: '',
    },
    // Posição do ícone à esquerda
    iconLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Posição do ícone à direita
    iconRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Mostrar loader do botão
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Desabilitar botão
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Colocar borda ao redor do botão
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão plano, sem efeitos
    plain: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão redondo
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão em tamanho muito pequeno
    xsmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão em tamanho pequeno
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão em tamanho grande
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Botão em tamanho muito grande
    xlarge: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é verde
    green: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é vermelho
    red: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é amarelo
    yellow: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Se o botão é branco
    whiteBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Elevação do botão (sombra)
    elevation: {
      required: false,
    },
    // Tamanho do ícone
    iconSize: {
      type: String,
      required: false,
      default: '',
    },
    // Nome do botão
    name: {
      type: String,
      required: false,
      default: '',
    },
    // Necessário para triggers como menus ou tooltips
    on: {},
    extraClass: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>

<style>
  .btn:not(.v-btn--fab) {
    text-transform: none !important;
    border-radius: 8px;
    height: 36px !important;
  }
  .btn > .v-btn__content > .v-icon {
    margin-top: 2px;
  }
  .greenBtn {
    background-color: var(--secondary) !important;
    color: var(--text) !important;
  }
  .redBtn {
    background-color: var(--error) !important;
    color: var(--black) !important;
  }
  .yellowBtn {
    background-color: var(--warning) !important;
    color: var(--text) !important;
  }
  .whiteBtn {
    background-color: var(--main-button) !important;
    color: var(--text) !important;
  }
  .svg-prepend {
    margin-right: 8px;
    margin-top: 3px;
  }
  .svg-postpend {
    margin-left: 6px;
    margin-top: 4px;
    margin-right: 5px;
  }
  .svg-center {
    margin-left: 2px !important;
  }
  .left-icon {
    margin-left: -13px !important;
  }
  .right-icon {
    margin-left: 5px !important;
    margin-right: -16px !important;
  }
  .iconText {
    display: block;
    width: 100%;
  }
  .paddingBtn {
    padding: 40px 18px 40px 18px !important;
  }
  .textSlot {
    width: 100%;
    margin: 4px;
    overflow-wrap: break-word;
  }
</style>
